<template>
  <AuthLayout v-if="layoutType === 'auth'"/>
  <MainLayout v-if = "layoutType == 'main'"/>
  <PopupLayout v-else-if = "layoutType == 'popup'" />
 
</template>

<script>
import AuthLayout from "./layouts/AuthLayout.vue";
import MainLayout from "./layouts/MainLayout.vue";
import PopupLayout from './layouts/PopupLayout.vue'

export default {
  name: "App",
  components: { AuthLayout, MainLayout, PopupLayout },
  data() {
    return {
      layoutType: "auth",
    };
  },
  watch: {
    $route(to) {
      this.layoutType = to.name === "LoginPage" ? "auth" : to.meta.popup ? 'popup' : 'main' ;
    },
  },
};
</script>
